const modalStore = createStore("modal", {
  current: null,
  data: {},
  open (id, data = null){
    if (id == this.current && JSON.stringify(data) === JSON.stringify(this.data[id] ?? null)) return;
    document.body.classList.add('overflow-hidden');
    this.data[id] = JSON.parse(JSON.stringify(data));
    setTimeout(() => this.current = id);
  },
  close() {
    document.body.classList.remove('overflow-hidden');
    removeTrapFocus();
    this.current = null;
  },
  toggle(id, data) {
    if(this.current === id) {
      this.close();
    } else {
      this.open(id, data)
    }
  }
})

createComponent("Modal", ({ id, initialData = null }) => ({
  id,
  initialData,
  $modalEl: null,
  get modalData () {
    return modalStore.data[this.id]
  },
  get isOpen() {
    return modalStore.current === this.id;
  },
  open(data){
    modalStore.open(this.id, data ?? this.initialData)
  },
  get imageCaption() {
    if(!this.modalData) return;
    const image = this.modalData.images?.[this.modalData.selectedImage];
    const { objects } = Shopify.ImageAltData(image?.alt);
    const caption = objects.find(metadata => Object.prototype.hasOwnProperty.call(metadata, 'caption'))?.caption;
    return typeof caption === 'string' ? caption : '';
  },
  close(){
    this.removeEvents()
    modalStore.close()
  },
  toggle(data){
    if (this.isOpen) this.removeEvents();
    modalStore.toggle(this.id, data ?? this.initialData)
  },
  onKeyup (e) {
    if (e.key === 'Escape') this.close()
  },
  addEvents ($el) {
    document.addEventListener('keyup', this.onKeyup);
    if ($el) trapFocus($el)
  },
  removeEvents () {
    document.removeEventListener('keyup', this.onKeyup);
    removeTrapFocus();
  },
  trapFocus ($el) {
    if ($el) this.$modalEl = $el;
    if (this.isOpen) setTimeout(() => this.addEvents($el ?? this.$modalEl));
    else this.removeEvents()
  }
}))
